import { EntityType, EntitySpecificationType } from "@/types/Entity"

export function getEntitySpecificationByKey(
    entity: EntityType,
    key: string,
): EntitySpecificationType | undefined {
    return entity.specifications.find((item) => item.name === key)
}
